import { render, staticRenderFns } from "./DocumentTypeSearch.vue?vue&type=template&id=12447018&scoped=true&"
import script from "./DocumentTypeSearch.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeSearch.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeSearch.vue?vue&type=style&index=0&id=12447018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12447018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12447018')) {
      api.createRecord('12447018', component.options)
    } else {
      api.reload('12447018', component.options)
    }
    module.hot.accept("./DocumentTypeSearch.vue?vue&type=template&id=12447018&scoped=true&", function () {
      api.rerender('12447018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/wizard/components/DocumentTypeSearch.vue"
export default component.exports